import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { ViewEventScreen } from "../components";
import { Header } from "../components/post";
import usePermission from "@/hooks/usePermission";

export const Events = () => {
  const { showEvent } = usePermission();

  return (
    <ContentLayout title="Events" header={<Header />}>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only User can view this.</div>}
            allowedRoles={[ROLES.USER]}
            policyCheck={showEvent}
          >
            <ViewEventScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
